import { ADD_USER } from "redux/types";

const initialState = {
    userData: {
        user_id: '',
        area_id: '',
        email: '',
        name: '',
        role: '',
        auth: null
    }
}

export const userReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case ADD_USER:
            return state = {
                ...state,
                userData: { ...state.userData, ...actions.payload }
            }

        default:
            return state;
    }
}